import { AppLink } from "@/components/common/app-link";
import { ChevronRight } from "lucide-react";
import type { BeachDestination } from "@/lib/data/beach-destinations";

export default function BeachDestinationCard({ destination }: { destination: BeachDestination }) {
    return (
        <AppLink
            to={destination.href}
            className="group flex flex-col bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden h-full hover:shadow-md transition-shadow"
        >
            <div className="relative aspect-[4/3] overflow-hidden">
                <img
                    src={destination.image}
                    alt={destination.name}
                    className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 rounded-full bg-white/95 px-3 py-1 text-xs font-medium text-bleu-marine shadow-sm">
                    {destination.badge}
                </span>
            </div>

            <div className="flex flex-col flex-1 p-5 gap-3">
                <h3 className="text-xl font-exo-bold text-bleu-marine">{destination.name}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed line-clamp-4">
                    {destination.description}
                </p>

                <div className="flex flex-wrap gap-2 mt-auto pt-2">
                    {destination.tags.map((tag) => (
                        <span
                            key={tag.label}
                            className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1 text-xs text-slate-700"
                        >
                            <span aria-hidden>{tag.icon}</span>
                            {tag.label}
                        </span>
                    ))}
                </div>

                <span className="inline-flex items-center gap-1 text-sm font-medium text-bleu-ciel group-hover:text-bleu-marine transition-colors mt-2">
                    En savoir plus
                    <ChevronRight className="h-4 w-4" />
                </span>
            </div>
        </AppLink>
    );
}
